class AnimatedLine {
    constructor(container) {
        this.spans = container.querySelectorAll('span');
        this.currentIndex = 0;
        this.typingSpeed = 100;
        this.deletingSpeed = 50;
        this.pauseTime = typeof container.dataset.pause !== 'undefined' ? container.dataset.pause : 1500;
        this.isRunning = true;
        this.type = typeof container.dataset.type !== 'undefined' ? container.dataset.type : 'typing';
    }

    start() {
        this.spans[0].classList.add('current');
        this.animate();
    }

    async animate() {
        while (this.isRunning) {
            try {
                if (this.type === 'fade-in') {
                    await this.fadeInText();
                    await this.wait(this.pauseTime);
                    await this.fadeOutText();
                } else {
                    await this.typeText();
                    await this.wait(this.pauseTime);
                    await this.deleteText();
                }
            } catch (error) {
                console.error('Animation error:', error);
                // Reset and continue
                this.currentIndex = 0;
                this.spans[this.currentIndex].classList.add('current');
            }
        }
    }

    async typeText() {
        const currentSpan = this.spans[this.currentIndex];
        const text = currentSpan.textContent;
        currentSpan.textContent = '';

        for (let i = 0; i < text.length; i++) {
            await this.wait(this.typingSpeed);
            currentSpan.textContent += text[i];
        }
    }

    async deleteText() {
        const currentSpan = this.spans[this.currentIndex];
        const text = currentSpan.textContent;

        for (let i = text.length; i > 0; i--) {
            await this.wait(this.deletingSpeed);
            currentSpan.textContent = text.substring(0, i - 1);
        }

        currentSpan.classList.remove('current');
        currentSpan.textContent = text;

        this.nextItem();
    }

    nextItem() {
        this.currentIndex = (this.currentIndex + 1) % this.spans.length;
        this.spans[this.currentIndex].classList.add('current');
    }

    async fadeInText() {
        const currentSpan = this.spans[this.currentIndex];
    }

    async fadeOutText() {
        const currentSpan = this.spans[this.currentIndex];
        currentSpan.classList.remove('current');

        await this.wait(200);

        this.nextItem();
    }

    wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}

export default AnimatedLine;
